import React from 'react'
import { Spinner } from '@/components/admin/atoms/feedback/Spinner'
import styles from './ActionButton.module.scss'

type Variant = 'primary' | 'secondary' | 'ghost' | 'error' | 'outline' | 'success'
type Size = 'xs' | 'sm' | 'md' | 'lg'

interface ActionButtonProps {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  type?: 'button' | 'submit' | 'reset'
  variant?: Variant
  size?: Size
  loading?: boolean
  disabled?: boolean
  className?: never
}

const variantMap: Record<Variant, string> = {
  primary: styles.primary, secondary: styles.secondary, ghost: styles.ghost,
  error: styles.error, outline: styles.outline, success: styles.success,
}

const sizeMap: Record<Size, string> = {
  xs: styles.xs, sm: styles.sm, md: styles.md, lg: styles.lg,
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  children, onClick, type = 'button', variant = 'primary',
  size = 'md', loading = false, disabled = false,
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={[styles.button, variantMap[variant], sizeMap[size]].join(' ')}
  >
    {loading && <Spinner size="sm" />}
    {children}
  </button>
)
